export class VeterinariansRoutingRouteNames {
    public static readonly PracticeProfile = 'practice-profile';
    public static readonly VeterinarianIdParam = 'veterinarianId';
}
